<template>
  <div class="activity-rule-root">
    <div class="custom-nav-block" :class="[scrollTop ? 'nav-scrolling' : 'nav-default']" :style="`padding-top:${topBarHeight}px`">
      <van-nav-bar class="van-bar" :title="$t('lang.CallMotivation.k051')" left-arrow @click-left="goPrevious">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow00.webp" alt="" />
        </template>
      </van-nav-bar>
    </div>

    <div class="mayday-main">
      <div class="rules-scroll">
        <!-- About the Event -->
        <section class="rule-card">
          <h2 class="rule-card__title">{{ $t('lang.WorldCup.k014') }}</h2>
          <div class="rule-card__block">
            <p class="rule-p rule-p--numbered">
              <span class="rule-p__idx">1.</span>
              {{ $t('lang.WorldCup.k070') }}:
              <span v-if="eventDurationLine" class="rule-highlight rule-highlight--inline">{{ eventDurationLine }}</span>
            </p>
            <p class="rule-p rule-p--numbered">
              <span class="rule-p__idx">2.</span>
              {{ $t('lang.WorldCup.k091') }}
            </p>
          </div>
        </section>

        <!-- How to earn points -->
        <section class="rule-card">
          <h2 class="rule-card__title">{{ $t('lang.WorldCup.k071') }}</h2>
          <div class="rule-card__block">
            <p class="rule-p rule-p--numbered">
              <span class="rule-p__idx">1.</span>
              {{ $t('lang.WorldCup.k074') }}
            </p>
            <div class="rule-call-lines">
              <p class="rule-call-line">
                <span class="rule-call-line__bold">{{ $t('lang.WorldCup.k075') }}</span>
                <span class="rule-call-line__light">1 {{ $t('lang.CommonModule.k020') }} {{ $t('lang.WorldCup.k076') }}</span>
              </p>
              <p class="rule-call-line">
                <span class="rule-call-line__bold">{{ $t('lang.WorldCup.k077') }}</span>
                <span class="rule-call-line__light">3 {{ $t('lang.CommonModule.k021') }} {{ $t('lang.WorldCup.k076') }}</span>
              </p>
            </div>
            <p class="rule-p rule-p--numbered">
              <span class="rule-p__idx">2.</span>
              {{ $t('lang.WorldCup.k078') }}
            </p>
            <p class="rule-p rule-p--sub">{{ $t('lang.WorldCup.k079') }}</p>
            <p class="rule-p rule-p--sub">{{ $t('lang.WorldCup.k089') }}</p>
            <p class="rule-p rule-p--sub">{{ $t('lang.WorldCup.k080') }}</p>
          </div>
        </section>

        <!-- Milestone rewards -->
        <section class="rule-card">
          <h2 class="rule-card__title">{{ $t('lang.WorldCup.k066') }}</h2>
          <div class="rule-card__block">
            <p class="rule-p rule-p--numbered">
              <span class="rule-p__idx">1.</span>
              {{ $t('lang.WorldCup.k081') }}
            </p>
            <p class="rule-p rule-p--numbered">
              <span class="rule-p__idx">2.</span>
              {{ $t('lang.WorldCup.k082') }}
            </p>
            <div v-if="milestoneList.length" class="rule-reward-list">
              <div v-for="(item, index) in milestoneList" :key="index" class="rule-reward-row">
                <span class="rule-reward-rank">{{ item.points }} {{ $t('lang.WorldCup.k087') }}</span>
                <div class="rule-reward-val">
                  <span>{{ item.beans }}</span>
                  <img class="rule-reward-coin" :src="getMatchImg('beans')" alt="" />
                </div>
              </div>
            </div>
          </div>
        </section>

        <!-- Leaderboard Rewards -->
        <section class="rule-card">
          <h2 class="rule-card__title">{{ $t('lang.WorldCup.k067') }}</h2>
          <div class="rule-card__block">
            <p class="rule-p rule-p--numbered">
              <span class="rule-p__idx">1.</span>
              {{ $t('lang.WorldCup.k083') }}
            </p>
            <p class="rule-p rule-p--numbered">
              <span class="rule-p__idx">2.</span>
              {{ $t('lang.WorldCup.k084') }}
              <span v-if="actEndTime" class="rule-highlight rule-highlight--inline">{{ actEndTime }}</span>
            </p>
            <p class="rule-p rule-p--numbered">
              <span class="rule-p__idx">3.</span>
              {{ $t('lang.WorldCup.k085') }}
            </p>
            <div class="rule-reward-list">
              <div class="rule-reward-row">
                <span class="rule-reward-rank">No.1</span>
                <div class="rule-reward-val">
                  <span>{{ boardData.num1Reward }}</span>
                  <img class="rule-reward-coin" :src="getMatchImg('beans')" alt="" />
                </div>
              </div>
              <div class="rule-reward-row">
                <span class="rule-reward-rank">No.2</span>
                <div class="rule-reward-val">
                  <span>{{ boardData.num2Reward }}</span>
                  <img class="rule-reward-coin" :src="getMatchImg('beans')" alt="" />
                </div>
              </div>
              <div class="rule-reward-row">
                <span class="rule-reward-rank">No.3</span>
                <div class="rule-reward-val">
                  <span>{{ boardData.num3Reward }}</span>
                  <img class="rule-reward-coin" :src="getMatchImg('beans')" alt="" />
                </div>
              </div>
              <div class="rule-reward-row">
                <span class="rule-reward-rank">No.4-10</span>
                <div class="rule-reward-val">
                  <span>{{ boardData.num4Reward }}</span>
                  <img class="rule-reward-coin" :src="getMatchImg('beans')" alt="" />
                </div>
              </div>
            </div>
          </div>
        </section>

        <!-- Important notice -->
        <section class="rule-card">
          <h2 class="rule-card__title">{{ $t('lang.WorldCup.k090') }}</h2>
          <div class="rule-card__block">
            <p class="rule-p rule-p--numbered">
              <span class="rule-p__idx">1.</span>
              {{ $t('lang.WorldCup.k086') }}
            </p>
            <p class="rule-p rule-p--numbered">
              <span class="rule-p__idx">2.</span>
              {{ $t('lang.WorldCup.k092') }}
            </p>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import { normalActBaseInfo } from './apidir/api.js'

export default {
  data() {
    return {
      actStartTime: '',
      actEndTime: '',
      milestoneList: [],
      boardData: {
        num1Reward: 0,
        num2Reward: 0,
        num3Reward: 0,
        num4Reward: 0,
      },
    }
  },
  computed: {
    eventDurationLine() {
      if (!this.actStartTime || !this.actEndTime) return ''
      return `${this.actStartTime} - ${this.actEndTime}`
    },
  },
  methods: {
    fetchData() {
      normalActBaseInfo().then((resData) => {
        if (resData && !resData.error) {
          if (resData.startTimestamp) {
            this.actStartTime = this.handleMoment(resData.startTimestamp, 'YYYY-MM-DD HH:mm:ss')
          }
          if (resData.endTimestamp) {
            this.actEndTime = this.handleMoment(resData.endTimestamp, 'YYYY-MM-DD HH:mm:ss')
          }

          if (resData.milestoneStates && resData.milestoneStates.length) {
            this.milestoneList = resData.milestoneStates
          }

          if (resData.leaderboardRewards && resData.leaderboardRewards.length) {
            this.boardData.num1Reward = resData.leaderboardRewards[0] || 0
            this.boardData.num2Reward = resData.leaderboardRewards[1] || 0
            this.boardData.num3Reward = resData.leaderboardRewards[2] || 0
            this.boardData.num4Reward = resData.leaderboardRewards[3] || 0
          }
        }
      })
    },
  },
  created() {
    this.fetchData()
  },
  mounted() {
    document.body.scrollTo({ top: 0 })
  },
}
</script>

<style lang="less" scoped>
img:not([src]) {
  opacity: 0;
}

.activity-rule-root {
  width: 100%;
  min-height: 100vh;
  overflow-x: hidden;
  background: #3a4fff;

  .custom-nav-block {
    background: #3a4fff;

    &.nav-scrolling {
      background: #3a4fff;
    }
  }

  .left-nav,
  .right-nav {
    width: 24px;
    height: 24px;
    display: block;
  }

  .mayday-main {
    position: relative;
  }

  .rules-scroll {
    padding: 16px 10px 32px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    max-width: 375px;
    margin: 0 auto;
    box-sizing: border-box;
  }

  .rule-card {
    width: 100%;
    padding: 16px;
    border-radius: 12px;
    background: #f9fff5;
    box-sizing: border-box;
  }

  .rule-card__title {
    margin: 0 0 8px;
    font-family: 'TikTokSans-Regular', sans-serif;
    font-weight: 800;
    font-size: 17px;
    line-height: 22px;
    color: #363636;
  }

  .rule-card__block {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .rule-p {
    margin: 0;
    font-family: 'TikTokSans-Regular', sans-serif;
    font-size: 15px;
    line-height: 22px;
    color: #363636;
  }

  .rule-p--numbered {
    display: block;
  }

  .rule-p--sub {
    margin: 0;
    padding-left: 12px;
  }

  .rule-highlight {
    margin: 0;
    font-family: 'TikTokSans-Regular', sans-serif;
    font-weight: 600;
    font-size: 15px;
    line-height: 22px;
    color: #f48300;
  }

  .rule-highlight--inline {
    margin-left: 4px;
  }

  .rule-call-lines {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin: 4px 0 8px;
    padding-left: 12px;
  }

  .rule-call-line {
    margin: 0;
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
    gap: 5px;
    font-size: 17px;
    line-height: 22px;
    color: #363636;
  }

  .rule-call-line__bold {
    font-family: 'TikTokSans-Regular', sans-serif;
    font-weight: 800;
  }

  .rule-call-line__light {
    font-family: 'Roboto-Regular', sans-serif;
    font-weight: 400;
    font-size: 17px;
    color: #363636;
  }

  .rule-reward-list {
    margin-top: 8px;
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .rule-reward-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .rule-reward-rank {
    font-family: 'TikTokSans-Regular', sans-serif;
    font-size: 15px;
    color: #363636;
  }

  .rule-reward-val {
    display: flex;
    align-items: center;
    gap: 4px;
    font-family: 'TikTokSans-Regular', sans-serif;
    font-weight: 800;
    font-size: 15px;
    color: #363636;
  }

  .rule-reward-coin {
    width: 16px;
    height: 16px;
    object-fit: contain;
  }
}

::v-deep .van-nav-bar__title {
  font-size: 17px;
  font-family: 'TikTokSans-Regular', sans-serif;
  font-weight: 600;
  color: #ffffff;
}

::v-deep .van-nav-bar {
  background: transparent;
}

::v-deep .van-nav-bar .van-icon {
  color: #fff;
}
</style>
